/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取搜索历史
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.UserSearchHistory;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/search-history`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
